import type React from "react";
import { Paper, Tab, Tabs } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";

export type T2Tab =
  | "obituary"
  | "memories"
  | "favourites"
  | "timeline"
  | "donations"
  | "admin";

interface Template2TabBarProps {
  value: T2Tab;
  onChange: (newValue: T2Tab) => void;
  isAdmin: boolean;
  donationEnabled: boolean;
  accentColor?: string;
}

const icon = <CalendarTodayOutlinedIcon sx={{ fontSize: "0.9rem" }} />;

const Template2TabBar: React.FC<Template2TabBarProps> = ({
  value,
  onChange,
  isAdmin,
  donationEnabled,
  accentColor = "#E07E4A",
}) => (
  <Paper
    square
    sx={{
      width: "100%",

      bgcolor: "background.paper",
      position: "relative",

      "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: -4,
        height: 8,
        pointerEvents: "none",
        boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
      },
    }}
  >
    <Tabs
      value={value}
      onChange={(_e, v: T2Tab) => onChange(v)}
      variant="fullWidth"
      scrollButtons="auto"
      allowScrollButtonsMobile
      TabIndicatorProps={{ style: { backgroundColor: accentColor, height: 3 } }}
      sx={{
        px: { xs: 1, md: 3 },
        minHeight: 52,
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 500,
          fontSize: { xs: "0.8rem", md: "0.9rem" },
          minHeight: 52,
          gap: 0.5,
          color: "text.secondary",
        },
        "& .Mui-selected": {
          color: `${accentColor} !important`,
          fontWeight: 700,
        },
        "& .Mui-disabled": { opacity: 0.45 },
      }}
    >
      <Tab value="obituary" label="Obituary" icon={icon} iconPosition="start" />
      <Tab value="memories" label="Memories" icon={icon} iconPosition="start" />
      <Tab value="favourites" label="Favourites" icon={icon} iconPosition="start" />
      <Tab value="timeline" label="Timeline" icon={icon} iconPosition="start" />
      {donationEnabled && (
        <Tab
          value="donations"
          label="Donations"
          icon={<VolunteerActivismOutlinedIcon sx={{ fontSize: "0.9rem" }} />}
          iconPosition="start"
        />
      )}
      {isAdmin && (
        <Tab value="admin" label="Admin" icon={icon} iconPosition="start" />
      )}
    </Tabs>
  </Paper>
);

export default Template2TabBar;
